<template>
  <v-col md="6" sm="6" cols="12">
    <v-card>
      <v-img
        :src="
          blog.photo
            ? apiDomain + blog.photo
            : 'https://cdn.vuetifyjs.com/images/cards/sunshine.jpg'
        "
        height="200px"
      ></v-img>

      <v-card-title v-text="blog.title.substring(0, 20)"> </v-card-title>

      <v-card-subtitle>
        {{ blog.description.substring(0, 70) }}...
      </v-card-subtitle>

      <v-card-actions>
        <v-btn :to="'/blog/' + blog.id" color="orange lighten-2" text>
          Explore
        </v-btn>
      </v-card-actions>

      <div v-if="!edit">
        <v-card-actions>
          <v-btn block color="#C5E1A5" v-on:click="$emit('edit', blog)">
            Edit
          </v-btn>
        </v-card-actions>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn block color="#80DEEA" v-on:click="$emit('upload', blog)">
            Upload
          </v-btn>
        </v-card-actions>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn block color="#EF9A9A" v-on:click="$emit('delete', blog)">
            Delete
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  data: () => ({
    apiDomain: "https://demo-api-vue.sanbercloud.com",
  }),
  props: ["blog", "edit"],
};
</script>